// import React, { useState, useContext, useEffect } from "react";
// import { UrlContext } from "../../contexts/UrlContext";
// import Swal from "sweetalert2";
// import { set } from "date-fns";

// export default function TweakProfile({
//   projectID,
//   profile,
//   setIsTweak,
//   isCallScheduled,
//   setIsCallScheduled,
//   isCallConducted,
//   setIsCallConducted,
// }) {
//   const isDownloaded = "/pictures/";
//   const { API_URL } = useContext(UrlContext);
//   const [callStatus, setCallStatus] = useState(
//     isCallScheduled ? "scheduled" : isCallConducted ? "conducted" : null
//   );
//   const [loading, setLoading] = useState(false);

//   // useEffect(() => {
//   //   if (callStatus === "scheduled") {
//   //     setIsCallScheduled(true);
//   //     setIsCallConducted(false);
//   //   } else if (callStatus === "conducted") {
//   //     setIsCallConducted(true);
//   //     setIsCallScheduled(false);
//   //   } else {
//   //     setIsCallScheduled(false);
//   //     setIsCallConducted(false);
//   //   }
//   // }, [callStatus]);

//   const updateCallStatus = async () => {
//     if (callStatus === "scheduled") {
//       setIsCallScheduled(true);
//       setIsCallConducted(false);
//     } else if (callStatus === "conducted") {
//       setIsCallConducted(true);
//       setIsCallScheduled(false);
//     } else {
//       setIsCallScheduled(false);
//       setIsCallConducted(false);
//     }
//   };

//   // API for selecting a consultant
//   const tweakProfileDetails = async () => {
//     setLoading(true);
//     const requestBody = {
//       projectID: projectID,
//       expertID: profile.expertID,
//       callStatus: callStatus,
//     };
//     try {
//       let modifiedUrl = "tweak-shared-profile";
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         await updateCallStatus();
//         setIsTweak(false);
//       } else {
//         console.error("Failed to modify profile");
//         Swal.fire({
//           title: "Error!",
//           text: "Unexpected error!",
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (error) {
//       setIsTweak(false);
//       console.error("Error while calling the backend API:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Unexpected error!",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//     setLoading(false);
//   };

//   return (
//     <>
//       <div className="decline-wrapper">
//         <div
//           className="flex-container-decline-profile"
//           style={{
//             padding: "0px",
//             width: "600px",
//             height: "400px",
//             display: "flex",
//             flexDirection: "column",
//           }}
//         >
//           <div
//             className="flex-item-decline-profile-header"
//             style={{ flex: "5%", backgroundColor: "#365561" }}
//           >
//             <p
//               style={{
//                 fontSize: "16px",
//                 fontWeight: "500",
//                 marginLeft: "5px",
//                 color: "white",
//               }}
//             >
//               Edit Profile Details
//             </p>
//             <i
//               class="fa-solid fa-xmark"
//               style={{
//                 marginRight: "5px",
//                 marginTop: "3px",
//                 color: "gray",
//                 cursor: "pointer",
//               }}
//               onClick={() => setIsTweak(false)}
//             />
//           </div>

//           <div
//             className="flex-item-dicline-profile"
//             style={{
//               flex: "90%",
//               display: "flex",
//               flexDirection: "column",
//               overflowY: "auto",
//               justifyContent: "center",
//               alignItems: "center",
//               gap: "20px",
//             }}
//           >
//             <div>
//               {profile.expertProfilePicture ? (
//                 <>
//                   <div style={{ textAlign: "center", padding: "5px" }}>
//                     {profile.expertProfilePicture.includes(isDownloaded) ? (
//                       <img
//                         src={`https://images.expertpowerhouse.com${profile.expertProfilePicture}`}
//                         style={{
//                           width: "100px",
//                           height: "100px",
//                           borderRadius: "50%",
//                         }}
//                       />
//                     ) : (
//                       <img
//                         src={profile.expertProfilePicture}
//                         width={"50px"}
//                         alt=""
//                       />
//                     )}
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div style={{ textAlign: "center", padding: "5px" }}>
//                     <img
//                       src={`https://images.expertpowerhouse.com${"/pictures/dummy.png"}`}
//                       style={{
//                         width: "100px",
//                         height: "100px",
//                         borderRadius: "50%",
//                       }}
//                     />
//                   </div>
//                 </>
//               )}
//             </div>
//             <select
//               value={callStatus}
//               onChange={(e) => {
//                 setCallStatus(e.target.value);
//                 console.log(e.target.value);
//               }}
//               style={{
//                 width: "200px",
//                 padding: "5px",
//                 border: "1px solid lightgrey",
//               }}
//             >
//               <option value="0">Select Call Status</option>
//               <option value="scheduled">Call Scheduled</option>
//               <option value="conducted">Call Conducted</option>
//             </select>
//           </div>

//           <div
//             style={{
//               flex: "5%",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               gap: "10px",
//             }}
//           >
//             <button
//               className="btn base-btn"
//               onClick={() => tweakProfileDetails()}
//             >
//               Done
//             </button>
//             <button
//               className="btn btn-light"
//               style={{ border: "1px solid lightgrey" }}
//               onClick={() => setIsTweak(false)}
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }


import React, { useState, useContext, useEffect } from "react";
import { UrlContext } from "../../contexts/UrlContext";
import Swal from "sweetalert2";
import { set } from "date-fns";

export default function TweakProfile({
  projectID,
  profile,
  setIsTweak,
  isCallScheduled,
  setIsCallScheduled,
  isCallConducted,
  setIsCallConducted,
}) {
  const isDownloaded = "/pictures/";
  const { API_URL } = useContext(UrlContext);
  const [callStatus, setCallStatus] = useState(
    isCallScheduled ? "scheduled" : isCallConducted ? "conducted" : null
  );
  const [loading, setLoading] = useState(false);
  const fallbackProfilePicture = "https://images.expertpowerhouse.com/pictures/dummy.png";

  const updateCallStatus = async () => {
    if (callStatus === "scheduled") {
      setIsCallScheduled(true);
      setIsCallConducted(false);
    } else if (callStatus === "conducted") {
      setIsCallConducted(true);
      setIsCallScheduled(false);
    } else {
      setIsCallScheduled(false);
      setIsCallConducted(false);
    }
  };

  // API for selecting a consultant
  const tweakProfileDetails = async () => {
    setLoading(true);
    const requestBody = {
      projectID: projectID,
      expertID: profile.expertID,
      callStatus: callStatus,
    };
    try {
      let modifiedUrl = "tweak-shared-profile";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        await updateCallStatus();
        setIsTweak(false);
      } else {
        console.error("Failed to modify profile");
        Swal.fire({
          title: "Error!",
          text: "Unexpected error!",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      setIsTweak(false);
      console.error("Error while calling the backend API:", error);
      Swal.fire({
        title: "Error!",
        text: "Unexpected error!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
    setLoading(false);
  };

  const profilePictureUrl = profile?.expertProfilePicture
    ? profile.expertProfilePicture.includes(isDownloaded)
      ? `https://images.expertpowerhouse.com${profile.expertProfilePicture}`
      : profile.expertProfilePicture
    : fallbackProfilePicture;

  const statusOptions = [
    {
      value: "0",
      label: "No status",
      description: "Clear the current call status",
      icon: "fa-minus",
      selected:
        callStatus !== "scheduled" && callStatus !== "conducted",
    },
    {
      value: "scheduled",
      label: "Call scheduled",
      description: "A call has been arranged",
      icon: "fa-calendar-check",
      selected: callStatus === "scheduled",
    },
    {
      value: "conducted",
      label: "Call conducted",
      description: "The call has already taken place",
      icon: "fa-circle-check",
      selected: callStatus === "conducted",
    },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/45 px-3 py-4 backdrop-blur-sm sm:px-5">
      <div
        className="grid max-h-[92vh] w-full max-w-2xl grid-rows-[auto_minmax(0,1fr)_auto] overflow-hidden rounded-3xl border border-white/60 bg-white shadow-[0_24px_80px_rgba(15,23,42,0.28)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 bg-[#365561] px-4 py-3 text-white sm:px-5">
          <div className="min-w-0">
            <p className="truncate text-base font-semibold sm:text-lg">
              Edit Profile Details
            </p>
            <p className="mt-0.5 hidden truncate text-xs text-white/75 sm:block">
              Update the call status shared with the client.
            </p>
          </div>

          <button
            type="button"
            onClick={() => setIsTweak(false)}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-white/20 focus:outline-none"
            aria-label="Close edit profile dialog"
          >
            <i className="fa-solid fa-xmark text-base" />
          </button>
        </div>

        <div className="min-h-0 overflow-y-auto px-4 py-5 sm:px-5 sm:py-6">
          <div className="grid min-w-0 grid-cols-1 gap-4 sm:grid-cols-[auto_minmax(0,1fr)] sm:items-center">
            <div className="flex justify-center sm:justify-start">
              <img
                src={profilePictureUrl}
                alt=""
                className="h-20 w-20 rounded-2xl bg-[#365561] object-cover shadow-sm sm:h-20 sm:w-20"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = fallbackProfilePicture;
                }}
              />
            </div>

            <div className="min-w-0 text-center sm:text-left">
              <h5 className="text-base font-semibold text-slate-900 sm:text-lg">
                Select the consultant&apos;s call status
              </h5>
              <p className="mt-1 text-sm leading-5 text-slate-500">
                Choose the status that should be displayed for this shared
                profile.
              </p>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-3">
            {statusOptions.map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => {
                  setCallStatus(option.value);
                  console.log(option.value);
                }}
                className={[
                  "group rounded-2xl border p-3 text-left transition focus:outline-none",
                  option.selected
                    ? "border-[#365561] bg-[#365561] text-white shadow-[0_10px_22px_rgba(54,85,97,0.22)]"
                    : "border-slate-200 bg-slate-50 text-slate-600 hover:border-[#365561]/40 hover:bg-[#365561]/5 hover:text-[#365561]",
                ].join(" ")}
              >
                <span
                  className={[
                    "inline-flex h-9 w-9 items-center justify-center rounded-xl transition",
                    option.selected
                      ? "bg-white/15 text-white"
                      : "bg-white text-[#365561] shadow-sm group-hover:bg-white",
                  ].join(" ")}
                >
                  <i className={`fa-solid ${option.icon} text-sm`} />
                </span>

                <span className="mt-3 block text-sm font-semibold">
                  {option.label}
                </span>

                <span
                  className={[
                    "mt-1 block text-xs leading-4",
                    option.selected ? "text-white/75" : "text-slate-400",
                  ].join(" ")}
                >
                  {option.description}
                </span>
              </button>
            ))}
          </div>

          <div className="mt-5 flex items-start gap-2 rounded-2xl border border-[#365561]/10 bg-[#365561]/5 px-3 py-2.5">
            <i className="fa-solid fa-circle-info mt-0.5 text-xs text-[#365561]" />
            <p className="text-xs leading-5 text-slate-600">
              Saving this change updates only the call status for the selected
              consultant profile.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-2 border-t border-slate-200 bg-white/95 px-4 py-3 sm:grid-cols-[auto_auto] sm:justify-end sm:px-5">
          <button
            type="button"
            className="rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 focus:outline-none"
            onClick={() => setIsTweak(false)}
          >
            Cancel
          </button>

          <button
            type="button"
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#365561] px-4 py-2 text-sm font-semibold text-white shadow-[0_12px_24px_rgba(54,85,97,0.25)] transition hover:bg-[#2d4852] focus:outline-none"
            onClick={() => tweakProfileDetails()}
          >
            {loading && <i className="fa-solid fa-spinner fa-spin text-xs" />}
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
}